import PropTypes from 'prop-types';
import UILink from 'UIComponents/link/UILink';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const NewMessagesAlert = ({
  newMessageCount,
  onClickViewMessages,
  onClose
}) => {
  return /*#__PURE__*/_jsxs(Alert, {
    use: "inline",
    closeable: true,
    onClose: onClose,
    position: "absolute",
    maxInlineSize: "calc(100% - 50px)",
    marginInline: "auto",
    inlineSize: "fit-content",
    zIndex: 99,
    insetBlockStart: "60px",
    insetInlineStart: "0",
    insetInlineEnd: "0",
    children: [/*#__PURE__*/_jsx(View, {
      as: "span",
      marginInlineEnd: "100",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: 'conversations-thread-view.alerts.NEW_MESSAGES.alertLabel',
        options: {
          count: newMessageCount
        }
      })
    }), /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: 'conversations-thread-view.alerts.NEW_MESSAGES.view_jsx',
      options: {
        onClick: onClickViewMessages
      },
      elements: {
        Link: UILink
      }
    })]
  });
};
NewMessagesAlert.displayName = 'NewMessageAlert';
NewMessagesAlert.propTypes = {
  newMessageCount: PropTypes.number.isRequired,
  onClickViewMessages: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired
};
export default NewMessagesAlert;